/* eslint-disable react/no-did-mount-set-state react/no-multi-comp */

import React from 'react';
import classNames from 'classnames';


// This component was intended to allow archived items to fade out, but we have decided to leave
// archived items on the page until the next filter application. See github for code if you decide to
// turn this feature back on in the future
export default function ArchivedItem({ className, ...props }) {
  const Component = props.component || 'div';

  return (
    <Component className={classNames('archived-item', className)}>
      {props.children}
    </Component>
  );
}
